class WFAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcements = this.querySelectorAll('.wf-announcement-item');
    this.nextButton = this.querySelector('.wf-announcement-next');
    this.prevButton = this.querySelector('.wf-announcement-prev');
    this.currentIndex = 0;
    this.delay = this.getAttribute("data-delay");
    this.autoRotate = this.getAttribute("data-auto-rotate");
    console.log(this.delay, this.autoRotate);
    this.interval = null;
  }

  connectedCallback() {
    this.updateAnnouncementDisplay();
    this.setupEventListeners();
    if (this.autoRotate === 'true') {
      this.startAutoRotate();
    }
  }

  updateAnnouncementDisplay() {
    this.announcements.forEach((item, idx) => {
      item.classList.remove('active');
      if (idx === this.currentIndex) {
        item.classList.add('active');
      }
    });
  }

  nextAnnouncement() {
    this.announcements[this.currentIndex].style.transform = 'translateY(100%)';
    this.currentIndex = (this.currentIndex + 1) % this.announcements.length;
    this.announcements[this.currentIndex].style.transform = 'translateY(0)';
    this.updateAnnouncementDisplay();
  }

  prevAnnouncement() {
    this.announcements[this.currentIndex].style.transform = 'translateY(-100%)';
    this.currentIndex = (this.currentIndex - 1 + this.announcements.length) % this.announcements.length;
    this.announcements[this.currentIndex].style.transform = 'translateY(0)';
    this.updateAnnouncementDisplay();
  }

  resetInterval() {
    if (this.autoRotate === 'true' ) {
      clearInterval(this.interval);
      this.startAutoRotate();
    }
  }

  startAutoRotate() {
    this.interval = setInterval(() => this.nextAnnouncement(), this.delay);
  }

  stopAutoRotate() {
    clearInterval(this.interval);
  }

  setupEventListeners() {
    this.nextButton.addEventListener('click', () => {
      this.nextAnnouncement();
      this.resetInterval();
    });

    this.prevButton.addEventListener('click', () => {
      this.prevAnnouncement();
      this.resetInterval();
    });
  }

  disconnectedCallback() {
    this.stopAutoRotate();
    this.nextButton.removeEventListener('click', this.nextAnnouncement);
    this.prevButton.removeEventListener('click', this.prevAnnouncement);
  }
}

customElements.define('wf-announcement-bar', WFAnnouncementBar);


document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".wf-product-description");
  const readMoreBtn = document.querySelector(".wf-read-more-btn");
  if (!description || !readMoreBtn) return;
  const descriptionHeight = description.scrollHeight;

  if (descriptionHeight > 100) {
    description.classList.add("show--toggle");
    readMoreBtn.style.display = "block";
  }

  readMoreBtn.addEventListener("click", function () {
    description.classList.toggle("expanded");
    description.style.maxHeight = description.classList.contains("expanded")
      ? `${descriptionHeight}px`
      : "100px";
    readMoreBtn.textContent = description.classList.contains("expanded")
      ? "Weniger lesen"
      : "Weiterlesen";
  });
});
